module.exports = __webpack_public_path__ + "img/certificate-status-2.76f56332.png";